import { useState } from 'react';
import { action, computed, makeObservable, observable } from 'mobx';
import { Store } from '../../store/store';
import { StoreNode } from '../../store';
import { useStore } from '../../store/storeHooks';
import { OverlayAnchorJSXProps, OverlayEventHandlerName, OverlayState } from './overlayState';

type Props = {
  overlays?: Iterable<OverlayState>
}

// type OverlayDOMEventType =
//   React.MouseEvent |
//   React.PointerEvent |
//   React.FocusEvent;

// type OverlayDOMEventName =
//   'mouseenter' |
//   'mouseleave' |
//   'click' |
//   'focus' |
//   'blur';

// type OverlayTargetType =
//   'Anchor' |
//   'Overlay';

export class OverlayGroupState
  extends StoreNode {

  constructor(store: Store, props?: Props) {
    super(store, props);
    makeObservable<this, 'handleEvent'>(this, {
      exclusivelyVisibleOverlay: computed,
      handleEvent: action,
      hide: action,
      hideOtherOverlays: action,
      anchorProps: computed,
    });

    this.overlays.replace([...(props?.overlays || [])]);
  }

  readonly overlays = observable.array<OverlayState>();

  get exclusivelyVisibleOverlay(): OverlayState | null {
    return this.overlays.find(ovr => ovr.isExclusivelyVisible) ?? null;
  }

  handleAnchorMouseEnter = action((evt: React.MouseEvent) => {
    this.handleEvent('handleAnchorMouseEnter', evt);
  })
  handleAnchorMouseLeave = action((evt: React.MouseEvent) => {
    this.handleEvent('handleAnchorMouseLeave', evt);
  })
  handleAnchorClick = action((evt: React.MouseEvent) => {
    this.handleEvent('handleAnchorClick', evt);
  })
  handleAnchorFocus = action((evt: React.FocusEvent) => {
    this.handleEvent('handleAnchorFocus', evt);
  })
  handleAnchorBlur = action((evt: React.FocusEvent) => {
    this.handleEvent('handleAnchorBlur', evt);
  })

  private handleEvent<T extends React.SyntheticEvent>(cbName: OverlayEventHandlerName, evt: T) {

    // const exOvr = this.exclusivelyVisibleOverlay;
    // if (exOvr) {
    //   exOvr[cbName]?.call(exOvr, evt);
    // } else {
      this.overlays.forEach(ovr => {
        const handler = ovr[cbName] as unknown as ((evt: T) => void) | undefined;
        handler?.call(ovr, evt);
      });
    // }

    // const newExOvr = this.exclusivelyVisibleOverlay;
    // if (newExOvr)
    //   this.hideOtherOverlays(newExOvr);
  }

  hide() {
    this.overlays.forEach(ovr =>
      ovr.hide());
  }

  hideOtherOverlays(ovr: OverlayState) {
    this.overlays.forEach(otherOvr => {
      if (otherOvr === ovr)
        return;
      otherOvr.hide();
    });
  }

  get anchorProps(): OverlayAnchorJSXProps {
    const props: OverlayAnchorJSXProps = {};

    props.onMouseEnter = evt => this.handleAnchorMouseEnter(evt);
    props.onMouseLeave = evt => this.handleAnchorMouseLeave(evt);
    props.onClick = evt => this.handleAnchorClick(evt);
    props.onFocus = evt => this.handleAnchorFocus(evt);
    props.onBlur = evt => this.handleAnchorBlur(evt);

    return props;
  }
}

export function useOverlayGroupState(props?: Props): OverlayGroupState {

  const store = useStore();
  const overlays = props?.overlays || [];

  const init = new OverlayGroupState(store, {
    overlays
  });

  const [state] = useState(init);

  return state;
}